import "./Cart.module.css";
import MainNavigation from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import Footer from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <MainNavigation />
      <CartContent />
      <Footer />
    </div>;
}